import { usePageLayerGroupUpdated } from './usePageLayerGroupUpdated'
import { usePageLayerUpdated } from './usePageLayerUpdated'
import { usePageUpdated } from './usePageUpdated'

export const useReceiveMessage = () => {
  usePageLayerUpdated()
  usePageUpdated()
  usePageLayerGroupUpdated()
}
